module.exports = __webpack_public_path__ + "static/media/information.98421af8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/information.svg
// module id = 776
// module chunks = 0